import type { HelpFile } from '../../types/help'
import { CompareGrantsTestIds } from '../../../testids/CompareGrantsTestIds'

export const compareGrantsHelp: HelpFile = {
  docPage: '/docs/analytics/compare-grants',
  texts: {
    [CompareGrantsTestIds.cardTitleSelectIdentities]:
      'Pick the two identities (A and B) whose effective access to compare side by side.',
    [CompareGrantsTestIds.comboboxIdentityA]:
      'Search and select the first identity to compare.',
    [CompareGrantsTestIds.comboboxIdentityB]:
      'Search and select the second identity to compare against identity A.',
    [CompareGrantsTestIds.cardTitleCommonGrants]:
      'Grants shared by both identities — useful for spotting shared baseline access.',
    [CompareGrantsTestIds.cardTitleCommonCount]: null,
    [CompareGrantsTestIds.cardTitleOnlyInA]:
      'Grants held by identity A but not by B — access B is missing relative to A.',
    [CompareGrantsTestIds.cardTitleOnlyInACount]: null,
    [CompareGrantsTestIds.cardTitleOnlyInB]:
      'Grants held by identity B but not by A — access A is missing relative to B.',
    [CompareGrantsTestIds.cardTitleOnlyInBCount]: null,
    [CompareGrantsTestIds.colCommonTargetSystem]: null,
    [CompareGrantsTestIds.colCommonEnforcementObject]: null,
    [CompareGrantsTestIds.colCommonOperation]: null,
    [CompareGrantsTestIds.colCommonValidUntil]:
      'Expiry of the shared grant — empty means open-ended.',
    [CompareGrantsTestIds.colOnlyATargetSystem]: null,
    [CompareGrantsTestIds.colOnlyAEnforcementObject]: null,
    [CompareGrantsTestIds.colOnlyAOperation]: null,
    [CompareGrantsTestIds.colOnlyAValidUntil]:
      'Expiry of the grant held only by identity A — empty means open-ended.',
    [CompareGrantsTestIds.colOnlyBTargetSystem]: null,
    [CompareGrantsTestIds.colOnlyBEnforcementObject]: null,
    [CompareGrantsTestIds.colOnlyBOperation]: null,
    [CompareGrantsTestIds.colOnlyBValidUntil]:
      'Expiry of the grant held only by identity B — empty means open-ended.',
  },
}
